import { fetchLibrary } from '../../api/libraryPlayback';
import { RenderListItem } from '../../api/rendersApi';
import { BedtimePair } from '../../context/bedtime/bedtimeContextModel';
import { latestApprovedPerStory } from '../Renders/renderPresentation';

/** Exact-pair approved shelf, including independently approved shared sources.
 * Home and My stories use the same projection; playback revalidates separately.
 */
export async function fetchApprovedForPair(pair: BedtimePair, signal?: AbortSignal): Promise<RenderListItem[]> {
  const renders = await fetchLibrary(pair, signal);
  return latestApprovedPerStory(renders.filter((render) => (
    render.household_id === pair.householdId
    && render.listener_id === pair.listenerId
    && render.voice_id === pair.voiceId
  )));
}
